import {
  MANAGE_LOGIN_SUCCESS,
  MANAGE_LOGIN_FAILURE,
  MANAGE_LOGIN_NEEDS_TEAM,
  MANAGE_LOGOUT,
  MANAGE_FETCH_MEMBERSHIP_SUCCESS,
  MANAGE_FETCH_MEMBERSHIP_FAILURE,
  MANAGE_FETCH_REASONS_SUCCESS,
  MANAGE_FETCH_MEMBERSHIP_OPTIONS_SUCCESS,
  MANAGE_CANCEL_MEMBERSHIP_REQUEST,
  MANAGE_CANCEL_MEMBERSHIP_SUCCESS,
  MANAGE_CANCEL_MEMBERSHIP_FAILURE,
  MANAGE_REACTIVATE_MEMBERSHIP_SUCCESS,
  MANAGE_REACTIVATE_MEMBERSHIP_FAILURE,
  MANAGE_UPDATE_BILLING_SUCCESS,
  MANAGE_UPDATE_BILLING_FAILURE,
  MANAGE_DELETE_ACCOUNT_SUCCESS,
  MANAGE_DELETE_ACCOUNT_FAILURE,
  MANAGE_UPGRADE_MEMBERSHIP_SUCCESS,
  MANAGE_UPGRADE_MEMBERSHIP_FAILURE,
  MANAGE_VALIDATE_COUPON_SUCCESS,
  MANAGE_VALIDATE_COUPON_FAILURE,
  MANAGE_CLEAR_COUPON,
  MANAGE_CLEAR_UPGRADE_RESULT,
  MANAGE_CLEAR_ERROR,
} from '../actions/subscriptionActions';

const initialState = {
  token: null,
  membership: null,
  cancellationReasons: [],
  membershipOptions: [],
  loginError: null,
  error: null,
  membershipNotFound: false,
  cancelSuccess: false,
  cancelInProgress: false,
  reactivateSuccess: false,
  updateBillingError: null,
  upgradeError: null,
  upgradeResult: null,
  couponResponse: null,
  accountDeleted: false,
  teamsList: null,
  pendingCredentials: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case MANAGE_LOGIN_SUCCESS: {
      const { token } = action.data;
      return { ...state, token, loginError: null, teamsList: null, pendingCredentials: null };
    }

    case MANAGE_LOGIN_NEEDS_TEAM: {
      const { teamsList, pendingCredentials } = action;
      return { ...state, teamsList, pendingCredentials, loginError: null };
    }

    case MANAGE_LOGIN_FAILURE: {
      return { ...state, loginError: 'Invalid email or password. Please try again.' };
    }

    case MANAGE_LOGOUT: {
      return { ...initialState };
    }

    case MANAGE_FETCH_MEMBERSHIP_SUCCESS: {
      const membership = action.data.currentMembership;
      return { ...state, membership, error: null, membershipNotFound: false };
    }

    case MANAGE_FETCH_MEMBERSHIP_FAILURE: {
      console.error('MANAGE_FETCH_MEMBERSHIP_FAILURE', action.error);
      const gqlErrors = (action.error && action.error.graphQLErrors) || [];
      const networkError = action.error && action.error.networkError;
      const isNotFound = gqlErrors.some((e) => e.message === 'not_found');
      return {
        ...state,
        membershipNotFound: isNotFound,
        error: isNotFound
          ? null
          : networkError
          ? `Network error: ${networkError.message || networkError.statusCode || 'unknown'}`
          : 'Failed to load subscription. Please try again.',
      };
    }

    case MANAGE_FETCH_REASONS_SUCCESS: {
      const cancellationReasons = action.data.cancellationReasons;
      return { ...state, cancellationReasons };
    }

    case MANAGE_FETCH_MEMBERSHIP_OPTIONS_SUCCESS: {
      const membershipOptions = action.data.membershipOptions;
      return { ...state, membershipOptions };
    }

    case MANAGE_UPGRADE_MEMBERSHIP_SUCCESS: {
      return { ...state, upgradeError: null, upgradeResult: action.data.upgradeMembership, couponResponse: null };
    }

    case MANAGE_UPGRADE_MEMBERSHIP_FAILURE: {
      return { ...state, upgradeError: 'Failed to upgrade membership. Please try again.' };
    }

    case MANAGE_VALIDATE_COUPON_SUCCESS: {
      return { ...state, couponResponse: action.data.validateCoupon };
    }

    case MANAGE_VALIDATE_COUPON_FAILURE: {
      return { ...state, couponResponse: { valid: false } };
    }

    case MANAGE_CLEAR_COUPON: {
      return { ...state, couponResponse: null };
    }

    case MANAGE_CLEAR_UPGRADE_RESULT: {
      return { ...state, upgradeResult: null, upgradeError: null };
    }

    case MANAGE_CANCEL_MEMBERSHIP_REQUEST: {
      return { ...state, cancelInProgress: true, error: null };
    }

    case MANAGE_CANCEL_MEMBERSHIP_SUCCESS: {
      return { ...state, cancelSuccess: true, cancelInProgress: false, error: null };
    }

    case MANAGE_CANCEL_MEMBERSHIP_FAILURE: {
      return { ...state, cancelInProgress: false, error: 'Failed to cancel subscription. Please try again.' };
    }

    case MANAGE_CLEAR_ERROR: {
      return { ...state, error: null };
    }

    case MANAGE_REACTIVATE_MEMBERSHIP_SUCCESS: {
      return { ...state, reactivateSuccess: true, error: null };
    }

    case MANAGE_REACTIVATE_MEMBERSHIP_FAILURE: {
      return { ...state, error: 'Failed to reactivate subscription. Please try again.' };
    }

    case MANAGE_UPDATE_BILLING_SUCCESS: {
      return { ...state, updateBillingError: null };
    }

    case MANAGE_UPDATE_BILLING_FAILURE: {
      return { ...state, updateBillingError: 'Failed to update billing information. Please try again.' };
    }

    case MANAGE_DELETE_ACCOUNT_SUCCESS: {
      return { ...initialState, accountDeleted: true };
    }

    case MANAGE_DELETE_ACCOUNT_FAILURE: {
      return { ...state, error: 'Failed to delete account. Please try again.' };
    }

    default:
      return state;
  }
};
